import { Radio } from "ant-design-vue";
import lodash from "lodash";
import {
    createColumnDate,
    createColumnInlineAttachment, createColumnInlineInputPassword,
    createColumnInlineSelect,
    createColumnInput
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createButtonCreate } from "../../../../../utils/button";
import { conditionFormChecker, onClickDeleteAllClient } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createManageDelete, createManageExportCsv, createPage } from "../../../../../utils/page";
import { callProviderCa } from "./tab7.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/userCa";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey, isFillPassword } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    columns.push({
        title: () => i18n.global.t("views.company.mgt.tab.7.isChecked"),
        sorter: false,
        width: 100,
        align: "center",
        visible: () => true,
        visibleCsv: () => false,
        customRender: ({ record }) => {
            return (
                <Radio
                    checked={record.isChecked}
                    onUpdate:checked={() => {
                        items.forEach(item => {
                            item.isSave = true;
                            item.isChecked = false;
                        });
                        record.isChecked = true;
                    }}
                ></Radio>
            );
        },
        search: { visible: () => false }
    });
    columns.push(
        createColumnInput({
            title: () => i18n.global.t("model.attachment.documentName"),
            dataIndex: "documentName",
            dataIndexValue: () => i18n.global.t("views.company.mgt.tab.7.documentName"),
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.userCa.refProvider"),
            dataIndex: "refProvider",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callProviderCa, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callProviderCa,
                        optLabel: "value",
                        "onUpdate:value": value => (record.refProvider = value)
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnDate({
            title: () => i18n.global.t("views.company.mgt.tab.7.fileDate"),
            dataIndex: "updateDate"
        })
    );
    columns.push(
        createColumnInlineAttachment({
            title: () => i18n.global.t("views.company.mgt.tab.7.fileCer"),
            dataIndex: "attachmentCers.0",
            items,
            useForm,
            itemsKey,
            customKey: ({ itemIndex }) => `${itemsKey}.${itemIndex}.attachmentCers.0.size`,
            customRenderInputProp: ({ key }) =>
                lodash.merge(
                    { disabled: viewOnly, group: "CER", isUserFile: true, accept: ".cer,.crt" },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                ),
            width: 200
        })
    );
    columns.push(
        createColumnInlineAttachment({
            title: () => i18n.global.t("views.company.mgt.tab.7.fileP12"),
            dataIndex: "attachmentP12s.0",
            items,
            useForm,
            itemsKey,
            customKey: ({ itemIndex }) => `${itemsKey}.${itemIndex}.attachmentP12s.0.size`,
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        group: "P12",
                        isUserFile: true,
                        accept: ".p12",
                        "onUpdate:value": () => {
                            lodash.set(record, 'attachmentP12s.0.attribute.isFillPassword', isFillPassword);
                            lodash.set(record, 'attachmentP12s.0.attribute.isSave', true);
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                ),
            width: 200
        })
    );
    if (isFillPassword && !viewOnly) {
        columns.push(
            createColumnInlineInputPassword({
                title: () => i18n.global.t("views.company.mgt.tab.7.fileP12Password"),
                dataIndex: "attachmentP12s.0.attribute.password",
                items,
                useForm,
                itemsKey,
                customKey: ({ itemIndex }) => `${itemsKey}.${itemIndex}.attachmentP12s.0.attribute.password`,
                customRenderInputProp: ({ record, key }) =>
                    lodash.merge(
                        {
                            disabled: viewOnly,
                            "onUpdate:value": value => {
                                lodash.set(record, 'attachmentP12s.0.attribute.password', value);
                                lodash.set(record, 'attachmentP12s.0.attribute.isSave', true);
                                lodash.set(record, 'attachmentP12s.0.isSave', true);
                                record.isSave = true;
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    ),
                width: 200
            })
        );
    }
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [
        {
            render: () => createButtonCreate({ onClick: () => items.push({
                    attachmentCers: [], attachmentP12s: [],
                }) }),
            visible: () => (viewOnly ? false : canCreate)
        }
    ];
    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
